import React from "react";
import MFooterNavigation from "@/components/ui/atoms/MFooterNavigation";

const NavigationBarDemo: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-4 pb-28">
      <h1 className="text-2xl font-bold mb-6">Navigation Bar Demo</h1>

      <div className="bg-white rounded-lg shadow p-4 mb-4">
        <h2 className="text-lg font-medium mb-2">Default Navigation Bar</h2>
        <p className="text-gray-600 mb-4">
          The navigation bar below uses the default items configuration with
          Home, Documents, Insights, and Reminders. The active state is
          persisted in local storage.
        </p>
        <div className="h-16 bg-gray-100 rounded-lg flex items-center justify-center text-gray-500">
          Content Area (Navigation bar is fixed at bottom)
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-4 mb-4">
        <h2 className="text-lg font-medium mb-2">Usage</h2>
        <p className="text-gray-600 mb-4">
          Import and use the MNavigationBar component in your layout:
        </p>
        <pre className="bg-gray-100 p-3 rounded text-sm overflow-x-auto">
          {`import MNavigationBar from '@/components/ui/atoms/MNavigationBar';

// In your layout component:
<MNavigationBar />`}
        </pre>
      </div>

      <div className="bg-white rounded-lg shadow p-4 mb-4">
        <h2 className="text-lg font-medium mb-2">Custom Configuration</h2>
        <p className="text-gray-600 mb-4">
          You can provide custom navigation items:
        </p>
        <pre className="bg-gray-100 p-3 rounded text-sm overflow-x-auto">
          {`<MNavigationBar 
  items={[
    {
      id: 'custom1',
      label: 'Custom 1',
      icon: <CustomIcon />,
      activeIcon: <CustomActiveIcon />,
      path: '/custom1'
    },
    // More items...
  ]}
  storageKey="custom-nav-storage"
/>`}
        </pre>
      </div>

      {/* Add scrollable content to demonstrate fixed positioning */}
      <div className="bg-white rounded-lg shadow p-4 mb-4">
        <h2 className="text-lg font-medium mb-2">Scroll Test</h2>
        <p className="text-gray-600 mb-4">
          Scroll down to see that the navigation bar remains fixed at the bottom
          of the screen.
        </p>
        {Array(10)
          .fill(0)
          .map((_, i) => (
            <div
              key={i}
              className="h-24 bg-gray-100 rounded-lg mb-4 flex items-center justify-center text-gray-500"
            >
              Scroll Content {i + 1}
            </div>
          ))}
      </div>

      {/* Fixed position at the bottom */}
      <MFooterNavigation />
    </div>
  );
};

export default NavigationBarDemo;
